module.exports = __webpack_public_path__ + "img/ESH_Web_banner_day.b7be6356.png";